import { useEffect, useRef, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { Image } from 'foundations-components/transitional/components/Image';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Spacer } from 'foundations-components/components/Spacer';
import { mutateTrackerInstance, namespace } from '../tracking';
// @ts-expect-error bender-url not typed
import AnnouncementImg from 'bender-url!../../img/studio-announcement.png';
import useUserInfo from '../hooks/useUserInfo';
import { setUserAttribute } from '../api/userAttribute';
import { USER_ATTRIBUTES } from '../constants';
import useUserAttribute from '../hooks/useUserAttribute';
import CanvasContainer from './internal/CanvasContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function StudioBetaAnnouncementModal({
  appTrackerInstance,
  screen,
  subscreen,
  onClose,
  forceOpenForVR
}) {
  const [isOpen, setIsOpen] = useState(true);
  // Default to true so it doesn't show by default
  const {
    value: hasSeenBetaAnnouncementModal,
    loading: userAttributeLoading
  } = useUserAttribute(USER_ATTRIBUTES.HasSeenStudioBetaAnnouncementModal, 'false');
  const {
    track
  } = mutateTrackerInstance(appTrackerInstance);
  const hasTrackedView = useRef(false);
  const {
    isUngatedForBetaAnnouncementModal,
    loading: userInfoLoading
  } = useUserInfo();
  const shouldShowModal = forceOpenForVR || isOpen && !userInfoLoading && isUngatedForBetaAnnouncementModal() && !userAttributeLoading && hasSeenBetaAnnouncementModal !== 'true';

  // Mark as seen when component is visible
  useEffect(() => {
    if (shouldShowModal) {
      void setUserAttribute(USER_ATTRIBUTES.HasSeenStudioBetaAnnouncementModal, 'true');
    }
  }, [shouldShowModal]);
  useEffect(() => {
    if (!hasTrackedView.current && shouldShowModal) {
      track(namespace, 'Element Viewed', {
        screen,
        subscreen,
        action: 'View StudioBetaAnnouncementModal'
      });
      hasTrackedView.current = true;
    }
  }, [screen, subscreen, track, shouldShowModal]);
  const handleJoinBetaClick = () => {
    track(namespace, 'Element Interaction', {
      screen,
      subscreen,
      action: 'Click StudioBetaAnnouncementModalJoinBetaButton'
    });
  };
  const handleCloseClick = () => {
    track(namespace, 'Element Interaction', {
      screen,
      subscreen,
      action: 'Click StudioBetaAnnouncementModalCloseButton'
    });
    onClose === null || onClose === void 0 || onClose();
    setIsOpen(false);
  };
  if (!shouldShowModal) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "studio-beta-announcement-modal",
    use: "conversational",
    width: 792,
    size: "auto",
    centered: true,
    paddingBlockStart: "400",
    children: [/*#__PURE__*/_jsx(Spacer, {
      space: "800"
    }), /*#__PURE__*/_jsxs(DialogHeader, {
      use: "toolbar",
      children: [/*#__PURE__*/_jsxs(Text, {
        as: "h2",
        typography: "heading-600",
        marginBlock: "400",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketingDiscoveryUtils.studioBetaAnnouncementModal.title1"
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketingDiscoveryUtils.studioBetaAnnouncementModal.title2"
        })]
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleCloseClick,
        color: "icon-core-subtle"
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(View, {
        maxInlineSize: "655px",
        marginInline: "auto",
        children: /*#__PURE__*/_jsx(Text, {
          as: "p",
          textAlign: "center",
          typography: "body-100",
          color: "text-core-subtle",
          marginBlockEnd: "800",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketingDiscoveryUtils.studioBetaAnnouncementModal.description"
          })
        })
      }), /*#__PURE__*/_jsx(CanvasContainer, {
        children: /*#__PURE__*/_jsx(Image, {
          src: AnnouncementImg,
          alt: "Marketing Studio"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      padding: "0",
      children: /*#__PURE__*/_jsx(Flex, {
        inlineSize: "100%",
        paddingBlock: "400",
        paddingInline: "800",
        justifyContent: "space-between",
        borderBlockStartColor: "border-core-subtle",
        borderBlockStartWidth: "100",
        borderBlockStartStyle: "solid",
        children: /*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          onClick: handleJoinBetaClick,
          href: `/product-updates/${PortalIdParser.get()}/?rollout=180918`,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketingDiscoveryUtils.studioBetaAnnouncementModal.cta"
          })
        })
      })
    })]
  });
}